module.exports = __webpack_public_path__ + "static/media/complete-icon.6d9de0e5.svg";